module.exports = __webpack_public_path__ + "img/home-icon.ba44c906.svg";